import { useState } from "react"
import { SortDirection } from "../types/SortDirection"
import { TableSorterQuery } from "../types/TableSorterQuery"

export const useTableSorter = (
  initialValue?: TableSorterQuery,
  changeSortCallback?: (newSorterQuery?: TableSorterQuery) => void
) => {
  const [query, setQuery] = useState<TableSorterQuery | undefined>(initialValue ?? undefined)

  const handleSort = (columnClicked: string) => {
    if (query?.columnName === columnClicked && query?.direction === SortDirection.Ascending) {
      setQuery(undefined)
      changeSortCallback && changeSortCallback(undefined)
    } else {
      let direction: SortDirection

      if (columnClicked !== query?.columnName) {
        direction = SortDirection.Descending
      } else if (query.direction === SortDirection.Descending) {
        direction = SortDirection.Ascending
      } else {
        direction = SortDirection.Descending
      }

      setQuery({ columnName: columnClicked, direction: direction })
      changeSortCallback && changeSortCallback({ columnName: columnClicked, direction: direction })
    }
  }

  const bind = (columnClicked: string) => ({
    name: columnClicked,
    active: query?.columnName === columnClicked,
    direction: query?.columnName === columnClicked ? query?.direction : SortDirection.Descending,
    onClick: () => handleSort(columnClicked),
  })

  return {
    query,
    bind,
  }
}
